<template>
  <div>
    <div class="back-to-home rounded d-none d-sm-block">
      <router-link to="/" class="btn btn-icon btn-primary">
        <home-icon class="icons"></home-icon>
      </router-link>
    </div>
    <section class="bg-home bg-circle-gradiant d-flex align-items-center">
      <div class="bg-overlay bg-overlay-white"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-5 col-md-8">
            <div class="card login_page shadow rounded border-0">
              <div class="card-body">
                <h4
                  class="card-title text-center"
                  data-test="signup-page-title"
                >
                  {{ $t("auth:signup.text") }}
                </h4>
                <ValidationObserver v-slot="{ handleSubmit }">
                  <form
                    class="login-form mt-4"
                    @submit.prevent="handleSubmit(signup)"
                  >
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <ValidationProvider
                            mode="passive"
                            name="username"
                            rules="required|alpha_num|max:30|min:4"
                            v-slot="{ passed, failed, errors }"
                          >
                            <label
                              >{{ $t("auth:signup.labels.username") }}
                              <span class="text-danger">*</span></label
                            >
                            <div class="position-relative">
                              <user-icon class="fea icon-sm icons"></user-icon>
                              <input
                                data-test="signup-form-username"
                                v-model="user.username"
                                type="text"
                                class="form-control pl-5"
                                :placeholder="$t('auth:signup.labels.username')"
                                name="username"
                                :class="[
                                  { 'is-valid': passed },
                                  { 'is-invalid': failed },
                                ]"
                              />
                              <span
                                data-test="signup-form-username-helper-text"
                                class="text-danger"
                                style="font-size: 12px; font-weight: 700"
                                >{{ $t(errors[0]) }}</span
                              >
                            </div>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <ValidationProvider
                            mode="passive"
                            name="email"
                            rules="required|email"
                            v-slot="{ passed, failed, errors }"
                          >
                            <label
                              >{{ $t("auth:signup.labels.email") }}
                              <span class="text-danger">*</span></label
                            >
                            <div class="position-relative">
                              <mail-icon class="fea icon-sm icons"></mail-icon>
                              <input
                                data-test="signup-form-email"
                                v-model="user.email"
                                type="email"
                                class="form-control pl-5"
                                :placeholder="$t('auth:signup.labels.email')"
                                name="email"
                                :class="[
                                  { 'is-valid': passed },
                                  { 'is-invalid': failed },
                                ]"
                              />
                              <span
                                data-test="signup-form-email-helper-text"
                                class="text-danger"
                                style="font-size: 12px; font-weight: 700"
                                >{{ $t(errors[0]) }}</span
                              >
                            </div>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <ValidationProvider
                            mode="passive"
                            name="password"
                            rules="required|mandaa-password"
                            v-slot="{ passed, failed, errors }"
                          >
                            <label
                              >{{ $t("auth:signup.labels.password") }}
                              <span class="text-danger">*</span></label
                            >
                            <div class="position-relative">
                              <key-icon class="fea icon-sm icons"></key-icon>
                              <input
                                data-test="signup-form-password"
                                v-model="user.password"
                                type="password"
                                class="form-control pl-5"
                                :placeholder="$t('auth:signup.labels.password')"
                                :class="[
                                  { 'is-valid': passed },
                                  { 'is-invalid': failed },
                                ]"
                              />
                            </div>
                            <span
                              data-test="signup-form-password-helper-text"
                              class="text-danger"
                              style="font-size: 12px; font-weight: 700"
                              >{{ $t(errors[0]) }}</span
                            >
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <ValidationProvider
                            mode="passive"
                            name="select"
                            rules="required"
                            v-slot="{ passed, failed, errors }"
                          >
                            <label>
                              {{ $t("auth:signup.labels.plan.text") }}

                              <span class="text-danger">* </span></label
                            >
                            <select
                              data-test="signup-form-plan"
                              class="form-control custom-select"
                              :class="[
                                { 'is-valid': passed },
                                { 'is-invalid': failed },
                              ]"
                              v-model="planSelector.selectedOption"
                              @change="changePlan($event)"
                            >
                              <option value="undefined" disabled>
                                {{ $t("auth:signup.labels.plan.option") }}
                              </option>
                              <option
                                :value="option.value"
                                class="select-primary"
                                v-for="option in planSelector.options"
                                :label="option.label"
                                :key="option.label"
                              >
                                {{ option.label }}
                              </option>
                            </select>
                            <span
                              data-test="signup-form-plan-helper-text"
                              class="text-danger"
                              style="font-size: 12px; font-weight: 700"
                              >{{ $t(errors[0]) }}</span
                            >
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <div class="custom-control custom-checkbox">
                            <input
                              data-test="signup-form-tos"
                              required
                              type="checkbox"
                              class="custom-control-input"
                              :class="[
                                { 'is-valid': passed },
                                { 'is-invalid': failed },
                              ]"
                              id="customCheck1"
                            />
                            <label
                              class="custom-control-label"
                              for="customCheck1"
                              >{{ $t("auth:signup.accept") }}
                              <router-link to="/terms-service" class="text-primary">{{
                                $t("auth:signup.terms")
                              }}</router-link></label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <base-button
                          native-type="submit"
                          slot="footer"
                          :loading="isLoading"
                          type="primary"
                          round
                          block
                        >
                          <span data-test="signup-form-signup-button">
                            {{ $t("auth:signup.text") }}
                          </span>
                        </base-button>
                      </div>
                      <div class="mx-auto">
                        <p class="mb-0 mt-3">
                          <small class="text-dark mr-2">{{
                            $t("auth:signup.no_account")
                          }}</small>
                          <router-link
                            to="/login"
                            class="text-dark font-weight-bold"
                            >{{ $t("auth:signup.login") }}</router-link
                          >
                        </p>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* eslint-disable */
import HttpClientFactory from "../services/HttpClientFactory";
import { HomeIcon, MailIcon, KeyIcon, UserIcon } from "vue-feather-icons";
import { Select, Option } from "element-ui";
import lodash from "lodash";

export default {
  name: "Signup",
  data() {
    return {
      isLoading: false,
      user: {
        username: "",
        email: "",
        password: "",
        planId: null,
        lang: this.$i18n.i18next.language,
      },
      planIdSelected: "",
      planSelector: {
        selectedOption: undefined,
        options: [],
      },
    };
  },
  components: {
    HomeIcon,
    MailIcon,
    UserIcon,
    KeyIcon,
    [Option.name]: Option,
    [Select.name]: Select,
  },
  created() {
    this.getPlans();
  },
  methods: {
    changePlan(event) {
      this.planSelector.selectedOption = event.target.value;
      this.user.planId = event.target.value;
    },
    getPlans() {
      this.httpClient = HttpClientFactory.getInstance();
      this.httpClient
        .get(process.env.VUE_APP_BACKEND_ENDPOINT + "/plans/v1")
        .then(({ data }) => {
          const plansData = data;
          this.planSelector.options = plansData.map((plan) => {
            return {
              value: plan.id,
              label: plan.externalName,
              name: plan.internalName,
            };
          });
          const selectedPlan = this.$route.query.plan;

          if (selectedPlan !== undefined) {
            const selectedPlanOption = this.planSelector.options.find(
              (plan) => plan.name === selectedPlan
            );

            if (selectedPlanOption !== undefined) {
              this.planSelector.selectedOption = selectedPlanOption.value;
              this.user.planId = selectedPlanOption.value;
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    signup() {
      this.isLoading = true;
      this.httpClient = HttpClientFactory.getInstance();
      this.httpClient
        .post(
          process.env.VUE_APP_BACKEND_ENDPOINT + "/auth/v1/signup",
          this.user
        )
        .then(() => {
          this.isLoading = false;
          this.$notify({
            text: this.$t("auth:signup.success"),
            type: "success",
          });
          setTimeout(() => this.$router.push("login"), 2000);
        })
        .catch((e) => {
          this.isLoading = false;
          const field = lodash.snakeCase(e.response.data.errors[0].field);
          const rule = lodash.snakeCase(e.response.data.errors[0].rule);
          this.$notify({
            text: this.$t("auth:signup.validate." + rule + "_" + field, {
              username_min: 4,
              username_max: 30,
              password_min: 8,
            }),
            type: "warn",
          });
        });
    },
  },
};
</script>
